import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dSet from "../Data.Set/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dTraversable from "../Data.Traversable/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Restaumatic$dCart$dProductKey from "../Restaumatic.Cart.ProductKey/index.js";
import * as Restaumatic$dPromotions$dTypes$dPromotionalItem from "../Restaumatic.Promotions.Types.PromotionalItem/index.js";
import * as Restaumatic$dPromotionsEngine$dCart$dProductItem from "../Restaumatic.PromotionsEngine.Cart.ProductItem/index.js";
import * as Restaumatic$dPromotionsEngine$dCart$dPromotionalItem from "../Restaumatic.PromotionsEngine.Cart.PromotionalItem/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
const StoredPromotionalItem = x => x;
const storeItem = v => ({promotionId: v.promotion.promotionId, selection: v.selection, assignment: v.assignment, source: v.source, input: v.input});
const storePromotionalItems = /* #__PURE__ */ Data$dFunctor.arrayMap(storeItem);
const isValidAssignment = v => v1 => {
  if (v.tag === "TargetCart") { return v1.tag === "UnassignmentToCart" || v1.tag === "AssignmentToCart"; }
  if (v.tag === "TargetProductItems") {
    if (v1.tag === "UnassignmentToProduct") { return true; }
    if (v1.tag === "AssignmentToProduct") {
      return Data$dSet.foldableSet.foldMap({mempty: false, Semigroup0: () => ({append: v$1 => v1$1 => v$1 || v1$1})})((() => {
        const $0 = v1._1;
        return y => Restaumatic$dCart$dProductKey.eqProductKey.eq($0.product)(y.product) && $0.productSeq === y.productSeq;
      })())(v._1);
    }
    return false;
  }
  return false;
};
const updateItem = v => v1 => {
  if (v.promotionId === v1.promotion.promotionId) {
    if (isValidAssignment(v1.target)(v.assignment)) {
      return Data$dMaybe.$Maybe(
        "Just",
        {
          promotionalItemId: v1.promotionalItemId,
          promotion: v1.promotion,
          target: v1.target,
          source: v.source,
          assignment: v.assignment,
          selection: v.selection,
          input: v.input,
          value: v1.value,
          active: v1.active
        }
      );
    }
    return Data$dMaybe.Nothing;
  }
  return Data$dMaybe.Nothing;
};
const restorePromotionalItemAssignments = storedItems => engineItems => {
  if (storedItems.length === engineItems.length) {
    return Data$dTraversable.traversableArray.traverse(Data$dMaybe.applicativeMaybe)(x => x)(Data$dArray.zipWith(updateItem)(storedItems)(engineItems));
  }
  return Data$dMaybe.Nothing;
};
const genericStoredPromotionalItem = {to: x => x, from: x => x};
const showStoredPromotionalItem = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.showPromotionalItemSource(Restaumatic$dCart$dProductKey.showProductKey);
      const $1 = Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.showPromotionalItemAssignment(Restaumatic$dCart$dProductKey.showProductKey);
      return {
        genericShowArgs: v => [
          (() => {
            const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["assignment", $1.show(v.assignment)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "input",
              Restaumatic$dPromotions$dTypes$dPromotionalItem.showPromotionalItemInput.show(v.input)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["promotionId", Data$dShow.showIntImpl(v.promotionId)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "selection",
              Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.showSelectionStatus.show(v.selection)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["source", $0.show(v.source)]))([])))));
            if (v$1.length === 0) { return "{}"; }
            return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
          })()
        ]
      };
    })())({reflectSymbol: () => "StoredPromotionalItem"});
    return x => $0["genericShow'"](x);
  })()
};
const eqStoredPromotionalItem = {
  eq: /* #__PURE__ */ (() => {
    const $0 = Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.eqPromotionalItemSource(Restaumatic$dCart$dProductKey.eqProductKey);
    const $1 = Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.eqPromotionalItemAssignment(Restaumatic$dCart$dProductKey.eqProductKey);
    return x => y => $1.eq(x.assignment)(y.assignment) && (() => {
      if (x.input.tag === "FreeProductInput") {
        if (y.input.tag === "FreeProductInput") { return x.input._1.selection === y.input._1.selection; }
        return false;
      }
      if (x.input.tag === "NoInput") { return y.input.tag === "NoInput"; }
      return false;
    })() && x.promotionId === y.promotionId && Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.eqSelectionStatus.eq(x.selection)(y.selection) && $0.eq(x.source)(y.source);
  })()
};
const encodeStoredPromotionalItem = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericStoredPromotionalItem)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({
    reflectSymbol: () => "StoredPromotionalItem"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
      reflectSymbol: () => "source"
    })((() => {
      const $0 = Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.encodePromotionalItemSource(Restaumatic$dPromotionsEngine$dCart$dProductItem.encodeProductItemKey(Restaumatic$dCart$dProductKey.encodeProductKey)({
        encodeWithOptions: v => Restaumatic$dCart$dProductKey.encodeProductKey.encode
      }));
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "selection"})({encodeWithOptions: v => Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.encodeSelectionStatus.encode}))({
      reflectSymbol: () => "promotionId"
    })({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "input"})({
      encodeWithOptions: v => Restaumatic$dPromotions$dTypes$dPromotionalItem.encodePromotionalItemInput.encode
    }))({reflectSymbol: () => "assignment"})((() => {
      const $0 = Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.encodePromotionalItemAssignment(Restaumatic$dPromotionsEngine$dCart$dProductItem.encodeProductItemKey(Restaumatic$dCart$dProductKey.encodeProductKey)({
        encodeWithOptions: v => Restaumatic$dCart$dProductKey.encodeProductKey.encode
      }));
      return {encodeWithOptions: v => $0.encode};
    })());
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeStoredPromotionalItem = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericStoredPromotionalItem)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "StoredPromotionalItem"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "source"
  })(/* #__PURE__ */ (() => {
    const $0 = Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.decodePromotionalItemSource(Restaumatic$dPromotionsEngine$dCart$dProductItem.decodeProductItemKey(Restaumatic$dCart$dProductKey.decodeProductKey)({
      decodeWithOptions: v => Restaumatic$dCart$dProductKey.decodeProductKey.decode
    }));
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "selection"})({decodeWithOptions: v => Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.decodeSelectionStatus.decode})())({
    reflectSymbol: () => "promotionId"
  })({decodeWithOptions: v => Foreign.readInt(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "input"})({
    decodeWithOptions: v => Restaumatic$dPromotions$dTypes$dPromotionalItem.decodePromotionalItemInput.decode
  })())({reflectSymbol: () => "assignment"})(/* #__PURE__ */ (() => {
    const $0 = Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.decodePromotionalItemAssignment(Restaumatic$dPromotionsEngine$dCart$dProductItem.decodeProductItemKey(Restaumatic$dCart$dProductKey.decodeProductKey)({
      decodeWithOptions: v => Restaumatic$dCart$dProductKey.decodeProductKey.decode
    }));
    return {decodeWithOptions: v => $0.decode};
  })())())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  StoredPromotionalItem,
  decodeStoredPromotionalItem,
  encodeStoredPromotionalItem,
  eqStoredPromotionalItem,
  genericStoredPromotionalItem,
  isValidAssignment,
  restorePromotionalItemAssignments,
  showStoredPromotionalItem,
  storeItem,
  storePromotionalItems,
  updateItem
};
